module.exports = __webpack_public_path__ + "img/logo.d0f7f6be.png";